<template>
  <div class="pt-4 px-8">
    <el-form>
      <el-form-item label="运费模板">
        <el-button type="primary" size="small" @click="handlerCreate">添加规则</el-button>
      </el-form-item>
    </el-form>


    <el-table
        class="rc_table mt-4 w-full mb-4"
        row-key="id"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        ref="multipleTable"
        border
        :data="list"
    >
      <el-table-column align="center"  property="name" label="规则名称" width="120">
      </el-table-column>
      <el-table-column align="center"  property="freight_price" label="发货运费" show-overflow-tooltip width="600">
        <template slot-scope="scope">
          发货运费：
          {{scope.row.weight}}kg以内，{{scope.row.shipping_fee}}元，成本{{scope.row.shipping_cost}}元，每增加{{scope.row.weight_ext}}kg，增加运费{{scope.row.shipping_ext_fee}}元，成本{{scope.row.shipping_ext_cost}}元
          <br>
          退货运费：
          {{scope.row.return_weight}}kg以内，{{scope.row.return_shipping_fee}}元，成本{{scope.row.return_shipping_cost}}元，每增加{{scope.row.return_weight_ext}}kg，增加运费{{scope.row.return_shipping_ext_fee}}元，成本{{scope.row.return_shipping_ext_cost}}元
        </template>
      </el-table-column>
      <el-table-column align="center"  property="region_ids" label="收货地区" width="300">
        <template slot-scope="scope">
          {{scope.row.is_default==1?'默认规则':scope.row.region_name}}
        </template>
      </el-table-column>
      <el-table-column align="center"  property="create_time" label="创建时间" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          {{scope.row.create_time}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="left" width="200">
        <template slot-scope="scope">
          <div class="flex gap-x-4">
            <p class="opts green" @click="handlerEdit(scope.row)">修改</p>
            <p class="opts" @click="handlerDelete(scope.row)">删除</p>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        class="mb-4"
        background
        layout="total,prev, pager, next"
        hide-on-single-page
        :current-page="page_data.page"
        :total="page_data.total"
        :page-size="page_data.limit"
        @current-change="handlerPageChange"
    ></el-pagination>

    <BaseDialog ref="dialog" @save="getList"></BaseDialog>
  </div>
</template>

<script>
import {deleteFreightTemplate, getFreightTemplateList} from "@/api/main/ucenter";
import BaseDialog from "./dialog.vue"

export default{
  data(){
    return {
      list: [],
      page_data: {
        limit: 10,
        page: 1,
        total:0,
      },
    }
  },
  components:{
    BaseDialog
  },
  mounted() {
    this.getList();
  },
  methods:{
    handlerPageChange(e){
      this.page_data.page = e;
      this.getList();
    },
    getList(){
      getFreightTemplateList({limit:this.page_data.limit,page:this.page_data.page}).then(res=>{
        if(res.code == 200){
          this.list = res.data.lists.data
          this.page_data.total = res.data.lists.total
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    handlerCreate(){
      this.$refs.dialog.open();
    },
    handlerEdit(row){
      this.$refs.dialog.open(row);
    },
    handlerDelete(row){
      this.$confirm('删除后无法恢复，是否继续？')
          .then(() => {
            deleteFreightTemplate({id: row.id}).then(res=>{
              if(res.code == 200){
                this.$message.success(res.msg);
                this.getList();
              }else{
                this.$message.error(res.msg);
              }
            })
          })
    },
  }
}
</script>

<style scoped>
.opts{color: var(--red);cursor: pointer;margin-top: 6px;display:inline-block;}
.opts.green{color: #0ea11f;}
.opts:hover{text-decoration: underline;}
</style>
